// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14z-k","controls":"styles_controls__3w0fz","charLimit":"styles_charLimit__2tvQP","input":"styles_input__1xJx1","send":"styles_send__iMorF"};